/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateAddressResponseDto
 */
export interface UpdateAddressResponseDto {
    /**
     * Address unique identifier
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'id': string;
    /**
     * User ID who owns this address
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'userId': string;
    /**
     * Address name/label
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'name': string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'contactNumber': string;
    /**
     * Address type
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'type': UpdateAddressResponseDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'country': string;
    /**
     * Country code
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'countryCode': string;
    /**
     * Province name
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'province': string;
    /**
     * Province code
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'provinceCode': string;
    /**
     * City name
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'sourceApi'?: UpdateAddressResponseDtoSourceApiEnum;
    /**
     * Full formatted address
     * @type {string}
     * @memberof UpdateAddressResponseDto
     */
    'fullAddress'?: string;
}

export const UpdateAddressResponseDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type UpdateAddressResponseDtoTypeEnum = typeof UpdateAddressResponseDtoTypeEnum[keyof typeof UpdateAddressResponseDtoTypeEnum];
export const UpdateAddressResponseDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateAddressResponseDtoSourceApiEnum = typeof UpdateAddressResponseDtoSourceApiEnum[keyof typeof UpdateAddressResponseDtoSourceApiEnum];


